import React from 'react'
import { TermsContainer } from './styles'
import {
  FaFileContract,
  FaUserLock,
  FaFileCode,
  FaShieldHalved,
  FaTrashCan,
  FaCopyright,
  FaTriangleExclamation,
  FaPenToSquare,
  FaScaleBalanced,
  FaArrowLeft,
} from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'

export default function Terms() {
  const navigate = useNavigate()
  return (
    <TermsContainer>
      <div className='hero-section'>
        <button className='back-button' onClick={() => navigate(-1)}>
          <FaArrowLeft /> Voltar
        </button>
        <div className='hero-icon-wrapper'>
          <FaFileContract className='hero-icon' />
        </div>
        <h1>Termos de Uso e Privacidade</h1>
        <p className='hero-description'>
          Bem-vindo ao <strong>GID</strong>. Estabelecemos diretrizes claras para garantir a
          segurança, transparência e o bom uso da nossa plataforma.
        </p>
      </div>

      <div className='document-body'>
        <div className='section-block'>
          <h2>
            <FaUserLock className='section-icon' /> 1. Acesso e Uso do Sistema
          </h2>
          <p>
            O acesso ao GID é restrito a usuários previamente autorizados. Você compromete-se a
            manter a confidencialidade de suas credenciais de acesso, sendo integralmente
            responsável por todas as atividades que ocorrerem sob a sua conta.
          </p>
        </div>

        <div className='section-block'>
          <h2>
            <FaFileCode className='section-icon' /> 2. Coleta e Integração de Dados
          </h2>
          <p>
            O GID funciona processando dados fornecidos pelo usuário. A alimentação do sistema é
            realizada primariamente através de arquivos de texto (formato <code>.txt</code>), que
            contêm informações de vendas, estoque e distribuição, enviados de forma sistêmica via
            integrador.
          </p>
        </div>

        <div className='section-block lgpd-highlight'>
          <h2>
            <FaShieldHalved className='section-icon lgpd-icon' /> 3. Conformidade com a LGPD
          </h2>
          <p>
            Em estrita conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº
            13.709/2018 - LGPD), garantimos que:
          </p>
          <ul>
            <li>
              <strong>Papel das Partes:</strong> Ao enviar os arquivos via integrador, você atua
              como
              <em> Controlador</em> dos dados, sendo responsável pela legalidade das informações. O
              GID atua estritamente como <em> Operador</em>.
            </li>
            <li>
              <strong>Finalidade:</strong> Os dados são utilizados única e exclusivamente para
              geração de relatórios, análises de vendas e controle de distribuição.
            </li>
            <li>
              <strong>Segurança:</strong> Implementamos medidas técnicas rigorosas para proteger os
              dados contra acessos não autorizados.
            </li>
          </ul>
        </div>

        <div className='section-block'>
          <h2>
            <FaTrashCan className='section-icon' /> 4. Retenção e Exclusão
          </h2>
          <p>
            Os dados processados serão armazenados apenas pelo tempo necessário. O Controlador pode
            solicitar a exclusão ou anonimização das informações hospedadas a qualquer momento,
            desde que não infrinja exigências legais.
          </p>
        </div>

        <div className='section-block'>
          <h2>
            <FaCopyright className='section-icon' /> 5. Propriedade Intelectual
          </h2>
          <p>
            A estrutura, o código-fonte, os logotipos e a interface do GID são de propriedade
            exclusiva dos seus desenvolvedores. É expressamente proibida a cópia, engenharia reversa
            ou distribuição não autorizada.
          </p>
        </div>

        <div className='section-block'>
          <h2>
            <FaTriangleExclamation className='section-icon' /> 6. Limitações
          </h2>
          <p>
            O GID compromete-se a manter a alta disponibilidade, mas não se responsabiliza por
            inconsistências nos arquivos <code>.txt</code> enviados pelo integrador ou falhas de
            conexão de terceiros.
          </p>
        </div>

        <div className='section-block'>
          <h2>
            <FaPenToSquare className='section-icon' /> 7. Modificações
          </h2>
          <p>
            Reservamo-nos o direito de atualizar estes termos para refletir mudanças legais ou
            melhorias operacionais. Alterações significativas serão notificadas diretamente no
            painel.
          </p>
        </div>

        <div className='section-block'>
          <h2>
            <FaScaleBalanced className='section-icon' /> 8. Lei Aplicável
          </h2>
          <p>
            Estes termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o
            foro da comarca da sede da empresa desenvolvedora para dirimir quaisquer dúvidas.
          </p>
        </div>
      </div>

      <footer>
        <div className='footer-content'>
          <p>
            <strong>Atualizado em:</strong> Abril de 2026
          </p>

          <p className='copyright'>
            &copy; {new Date().getFullYear()} GID - Gestão de Informação do Distribuidor.
          </p>
        </div>
      </footer>
    </TermsContainer>
  )
}
